import { z } from '@hono/zod-openapi'
import { zSelectClient } from '../client/client.zod'
import { zSelectServiceProviderCategory } from '../service-provider-category/service-provider-category.zod'
import { zSelectVendor } from '../vendor/vendor.zod'
import { zSelectUser } from './user.zod'

export const zUserWithRelations = zSelectUser.extend({
    vendor: zSelectVendor.nullable().optional(),
    client: zSelectClient.nullable().optional(),
})

export type UserWithRelations = z.infer<typeof zUserWithRelations>

export const zUserWithClient = zSelectUser.extend({
    client: zSelectClient.nullable().optional(),
})

export type UserWithClient = z.infer<typeof zUserWithClient>

export const zSelectClientUser = zSelectUser.omit({
    vendorId: true,
    restauthUserId: true,
    restauthMembershipId: true,
})

export type SelectClientUser = z.infer<typeof zSelectClientUser>

export const zUserDetails = zSelectUser.extend({
    vendor: zSelectVendor
        .extend({
            category: zSelectServiceProviderCategory.nullable().optional(),
        })
        .nullable()
        .optional(),
    client: zSelectClient.nullable().optional(),
    benefitApplicationsCount: z.number(),
})

export type UserDetails = z.infer<typeof zUserDetails>
